import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.patternEscape_1 = new RegExp('[\\\\^$*+?.()|[\\]{}]', 'g');
        this.replacementEscape_1 = new RegExp('[\\\\$]', 'g');
        this.nativeReplacementEscape_1 = new RegExp('\\$', 'g');
      }
      escape_984trb_k$(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.patternEscape_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '\\$&');
      }
      nativeEscapeReplacement_5elzqg_k$(literal) {
        // Inline function 'kotlin.text.nativeReplace' call
        var pattern = this.nativeReplacementEscape_1;
        // Inline function 'kotlin.js.asDynamic' call
        return literal.replace(pattern, '$$$$');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance3che4h0wuq1kd,
};
//endregion

//# sourceMappingURL=regex.mjs.map
